module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "locationDataTranslateModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LTM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.LTM001) + " / " + _vm._s(_vm.lang.LTM002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    ref: "selectLocalizedLocationDataCountryCode",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.LTM003,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedLanguage = ''
      },
      "open": function($event) {
        _vm.currentTranslationDataDirty && _vm.showDirtyDataWarning()
      }
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                " + _vm._s(country) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    ref: "selectLocalizedLocationDataLanguageCode",
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.selectedCountry,
      "placeholder": _vm.lang.LTM004,
      "allowClear": true
    },
    on: {
      "open": function($event) {
        _vm.currentTranslationDataDirty && _vm.showDirtyDataWarning()
      }
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentCountryLanguages), function(language) {
    return _c('option', {
      key: language.LanguageCode,
      domProps: {
        "value": language.LanguageCode
      }
    }, [_vm._v("\n                " + _vm._s(language.LanguageName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fab",
    attrs: {
      "disabled": !_vm.selectedLanguage || !_vm.currentTranslationData.LocationGuid
    },
    on: {
      "click": function($event) {
        return _vm.deleteTranslationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-red"
  }, [_vm._v("clear")])])]), _vm._v(" "), (_vm.selectedLanguage) ? [(!_vm.currentTranslationData.LocationGuid) ? _c('div', {
    staticClass: "col-md-12 location-translation-form"
  }, [_vm._v("\n              " + _vm._s(_vm.lang.LTM005) + "\n              "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-fab",
    on: {
      "click": function($event) {
        return _vm.addNewTranslationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])])]) : _c('div', {
    staticClass: "col-md-12 location-translation-form",
    on: {
      "input": function($event) {
        _vm.currentTranslationDataDirty = true
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationName"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM006))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationName))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationName),
      expression: "currentTranslationData.LocationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM007))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationAddress))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationAddress),
      expression: "currentTranslationData.LocationAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationAddress",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM008))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationAddress2))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationAddress2),
      expression: "currentTranslationData.LocationAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationAddress2",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationCounty"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM009))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationCounty))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationCounty),
      expression: "currentTranslationData.LocationCounty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationCounty",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationCounty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM010))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationCity))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationCity),
      expression: "currentTranslationData.LocationCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationCity",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM011))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationPostalCode))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationPostalCode),
      expression: "currentTranslationData.LocationPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationPostalCode",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationPostalCode", $event.target.value)
      }
    }
  })])])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LTM012) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.currentTranslationDataDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveLocalizedLocationData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LTM013) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d87b043","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationManagement/LocationDataTranslateModal.vue
// module id = 1660
// module chunks = 1